import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonPage, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import {
    arrowBack,
    folderOutline
} from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './MenuFiscal.css';

type Props = {
    abrirMenu: boolean;
};

const MenuFiscal: React.FC<Props> = (props: Props) => {
    const history = useHistory();
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("");
    });

    return (
        <IonPage className="menu-layout-page">
            <IonHeader className="ion-no-border">
                <IonToolbar className="menu-layout-toolbar">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text='' />
                    </IonButtons>
                    <IonTitle slot="start">Fiscal</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="menu-layout-content">
                <div className="menu-layout-container">
                    <div className="menu-layout-heading">
                        <h1>Fiscal</h1>
                        <p>Consulte e acompanhe as notas fiscais da sua empresa.</p>
                    </div>
                    <nav className="menu-layout-grid" aria-label="Fiscal">

                        <h2 className="menu-layout-group">NFC-e</h2>



                        <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/fiscalhistorico" routerDirection="forward" detail
                            hidden={acessos?.fiscal != 'leitura' && acessos?.fiscal != 'edicao'}>
                            <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={folderOutline} />
                            <IonLabel><h3>Histórico de Notas</h3><p>Consulte as NFC-e emitidas e seus detalhes</p></IonLabel>
                        </IonItem>

                    </nav>
                </div>

                <IonToast
                    isOpen={showToast}
                    position="middle"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />
            </IonContent>
        </IonPage>
    );
};

export default MenuFiscal;
